import { render } from "./CISCO.vue?vue&type=template&id=40c3c675"
import script from "./CISCO.vue?vue&type=script&lang=ts"
export * from "./CISCO.vue?vue&type=script&lang=ts"
script.render = render

export default script